<template>
  <div>
    <div v-if="!hasCurrentProcessData" class="flex flex-row justify-center">
      <vs-button
        color="primary"
        type="border"
        @click="executeCreateProcess"
        class="font-bold"
      >
        Iniciar Integração
      </vs-button>
    </div>

    <div v-if="hasCurrentProcessData">
      <div class="flex flex-row gap-4 justify-between items-center">
        <div class="flex gap-2 items-center">
          <span class="font-bold">Processo Atual:</span>
          <span>{{ getActionLabel(currentProcessData.currentProcess) }}</span>
          <vs-chip :color="getChipColor(currentProcessData.status)">
            <b>{{ getStatusLabel(currentProcessData.status) }}</b>
          </vs-chip>
        </div>
        <div class="flex gap-2">
          <span class="font-bold">Atualização:</span>
          <span>{{
            functions.formatDateAndHour(currentProcessData.updatedAt)
          }}</span>
        </div>
        <vs-button
          icon="refresh"
          @click="reloadData"
          color="primary"
          type="border"
        />
      </div>

      <div
        v-if="showActions"
        class="actions-container mt-4 flex items-center gap-2"
      >
        <span class="font-bold">Ações:</span>

        <vs-button
          v-if="currentProcessData.status === 'FAILED'"
          color="warning"
          type="border"
          @click="executeRetryProcess"
          class="font-bold"
        >
          Reenviar
        </vs-button>

        <div
          v-if="currentProcessData.status === 'SUCCESS'"
          class="flex gap-8 items-center"
        >
          <v-select
            v-model="selectedAction"
            :options="actionOptions"
            label="label"
            value="value"
            placeholder="Selecionar Ação"
            style="width: 400px"
          ></v-select>
          <vs-button
            color="primary"
            type="border"
            :disabled="!selectedAction"
            @click="executeAction"
            class="font-bold"
          >
            Executar
          </vs-button>
        </div>
      </div>

      <vs-divider></vs-divider>
    </div>

    <div v-if="hasLogsData">
      <h5 class="mb-4">Histórico</h5>
      <div v-for="(item, index) in logsData" :key="index">
        <div class="flex flex-row gap-4 justify-start">
          <div class="flex flex-col w-1/4">
            <span class="font-bold">Ação:</span>
            <span>{{ getActionLabel(item.actionType) }}</span>
          </div>
          <div class="flex flex-col w-1/2">
            <span class="font-bold">Retorno:</span>
            <span>{{ item.message }}</span>
          </div>
          <div class="flex flex-col w-1/4">
            <span class="font-bold">Data Envio:</span>
            <span>{{ functions.formatDateAndHour(item.createdAt) }}</span>
          </div>
          <div class="flex flex-col w-1/4">
            <span class="font-bold">Usuário:</span>
            <span>{{ formatResponsavel(item) }}</span>
          </div>
          <div class="flex flex-col w-24">
            <span class="font-bold">Status:</span>
            <vs-chip :color="getChipColor(item.status)">
              {{ getStatusLabel(item.status) }}
            </vs-chip>
          </div>
        </div>
        <vs-divider></vs-divider>
      </div>
    </div>
  </div>
</template>

<script>
import functions from '../../../../utils/functions';
import vSelect from 'vue-select';
import notify from '../../../../utils/notify';
import venitiApiService from '../../../../services/veniti.api';
import { VENITI_MANUAL_ACTIONS } from '@/utils/constants';
import { formatResponsavel } from '../../../../utils/integrationHelpers';

export default {
  name: 'VenitiIntegrationContent',
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      default: () => ({ currentProcess: {}, logs: [] }),
    },
    policyId: Number,
    reload: Function,
  },
  data() {
    return {
      functions,
      selectedAction: null,
      actionOptions: [
        VENITI_MANUAL_ACTIONS.UPDATE_BENEFICIARY,
        VENITI_MANUAL_ACTIONS.UPDATE_VEHICLE,
        VENITI_MANUAL_ACTIONS.UPDATE_COVERAGE_PLAN,
        VENITI_MANUAL_ACTIONS.DISABLE_BENEFFICIARY,
        VENITI_MANUAL_ACTIONS.DISABLE_VEHICLE,
        VENITI_MANUAL_ACTIONS.REMOVE_COVERAGE_PLAN,
        VENITI_MANUAL_ACTIONS.CANCEL_POLICY,
      ],
    };
  },
  computed: {
    currentProcessData() {
      return this.data.currentProcess || {};
    },
    logsData() {
      return this.data.logs || [];
    },
    hasCurrentProcessData() {
      return Object.keys(this.currentProcessData).length > 0;
    },
    hasLogsData() {
      return this.logsData.length > 0;
    },
    showActions() {
      return ['FAILED', 'SUCCESS'].includes(this.currentProcessData.status);
    },
  },
  methods: {
    formatResponsavel,
    getStatusLabel(status) {
      const labelByStatus = {
        FAILED: 'Falhou',
        ERROR: 'Erro',
        SUCCESS: 'Sucesso',
        PENDING: 'Pendente',
        PROCESSING: 'Processando',
      };
      return labelByStatus[status];
    },
    getChipColor(status) {
      const colorsByStatus = {
        FAILED: 'warning',
        ERROR: 'danger',
        SUCCESS: 'success',
        PENDING: 'gray',
        PROCESSING: 'primary',
      };
      return colorsByStatus[status];
    },
    getActionLabel(action) {
      const labelByAction = {
        REGISTER_BENEFICIARY: 'Registro de beneficiário',
        UPDATE_BENEFICIARY: 'Atualização de beneficiário',
        DISABLE_BENEFFICIARY: 'Desativar beneficiário',
        REGISTER_VEHICLE: 'Registro de veículo',
        UPDATE_VEHICLE: 'Atualização de veículo',
        DISABLE_VEHICLE: 'Desativar veículo',
        ADD_COVERAGE_PLAN: 'Adicionar plano de cobertura',
        UPDATE_COVERAGE_PLAN: 'Atualização plano de cobertura',
        REMOVE_COVERAGE_PLAN: 'Remover plano de cobertura',
        REGISTRATION_COMPLETE: 'Registro finalizado',
        CANCEL_POLICY: 'Cancelar apólice',
        CANCELLATION_COMPLETE: 'Cancelamento finalizado',
      };
      return labelByAction[action];
    },
    async reloadData() {
      await this.reload();
    },
    async executeAction() {
      if (!this.selectedAction) return;

      this.$vs.loading();

      const payload = {
        policyId: this.policyId,
      };

      if (this.selectedAction !== 'RESUME') {
        payload.process = this.selectedAction.value;
      }

      try {
        await venitiApiService.executeAction(payload);
        notify.notifySuccess(this.$vs, 'Ação enviada!');
        this.selectedAction = null;
        await this.reloadData();
      } catch (error) {
        notify.notifyFail(this.$vs, 'Falha ao enviar ação');
      } finally {
        this.$vs.loading.close();
      }
    },
    async executeRetryProcess() {
      this.selectedAction = 'RESUME';
      await this.executeAction();
    },
    async executeCreateProcess() {
      this.$vs.loading();
      try {
        await venitiApiService.createIntegrationProcess(this.policyId);
        notify.notifySuccess(this.$vs, 'Integração iniciada');
        await this.reloadData();
      } catch (error) {
        notify.notifyFail(this.$vs, 'Falha ao iniciar integração');
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style scoped>
.actions-container {
  display: flex;
  align-items: center;
}

.font-bold {
  font-weight: bold;
}
</style>
